import React, { useRef, useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import * as util from './commons';

const NumberBox = ({ value, onChange, seperate, width, hideZero }) => {
    const textRef = useRef(null);
    const [text, setText] = useState("");
    const [currentValue, setCurrentValue] = useState(0);

    useEffect(() => {
        var res = checkValue(String(value));
        setCurrentValue(res.number);
        setText(res.text);
    }, [value]); // Re-run effect if data, width, or height changes
    const checkValue = function(val){
        var txt = "";
        var v = "0";
        if(val){
            v = val;
            if(v == null) v= "0";
            if(v == "") v= "0";
        }
        v = util.ReplaceStr(v, ",", "");
        v = parseInt(v);
        if(seperate === true){
            txt = util.SeperatePrice(v);
        }
        else {
            txt = String(v);
        }
        if((hideZero === true)&&(v == 0)){
            txt = "";
        }
        return {number:v, text:txt};
    }
    const onInputChange = function(e){
        var val = '';
        val = (e.target && e.target.value) || '';
        var res = checkValue(val);
        if(res.number != currentValue){
            onChange(res.number);
        }
        setCurrentValue(res.number);
        setText(res.text);
    }

    return (
        <>
            <InputText onChange={(e) => onInputChange(e)} value={text} ref={textRef} style={{width:width+"px", textAlign:"center", direction:"ltr"}} maxLength={20} keyfilter={'int'} />
        </>
    )
};

export default NumberBox;